import { Record } from 'immutable'

export const FavoriteActivityRecord = Record({
  activityId: null,
  day: null,
  name: null,
  description: null,
  proQuote: null,
  proQuoteAuthor: null,
  image: null,
  videoId: null,
  videoThumbnail: null,
  createdAt: null,
  updatedAt: null,
  levelId: null,
  levelName: null,
  proTrackName: null,
  isFavorite: null,
})

export class FavoriteActivity extends FavoriteActivityRecord {}
